export default __webpack_public_path__ + "dist/media/Email.20aa8a02.svg";